export const TEACHING_WORKLOAD = '/teaching-workload/' as const
export const TEACHING_WORKLOAD_APPROVAL = `${TEACHING_WORKLOAD}approval` as const
export const TEACHING_WORKLOAD_APPROVAL_BY_ID = `${TEACHING_WORKLOAD}approval/:id(\\d+)?` as const
